import { Typography, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import CheckDetailTitle from './CheckDetailTitle'
import TimelineDotLine from '../components/TimelineDotLine'
import CheckRiskStatus from '../components/CheckRiskStatus'
import './checks.scss'

const CheckCade = ({ cadeCheck, level = 0 }) => {
  const { t } = useTranslation(['common', 'messages'])

  const hasChecks =
    cadeCheck?.checkDetails?.data &&
    Array.isArray(cadeCheck?.checkDetails?.data) &&
    cadeCheck?.checkDetails?.data?.length > 0

  const detail = hasChecks ? cadeCheck?.checkDetails?.data[0] : {}
  const checkLength = detail?.andamentos?.length || 0
  const checkLength2 = detail?.protocolos?.length || 0

  return (
    <>
      <Paper elevation={0} variant="colorPrimary" sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography>{t('common:cade')}</Typography>
        <div className="c-detail-row">
          <CheckRiskStatus checkLength={checkLength} hasChecks={hasChecks} label="Andamento" />
          <CheckRiskStatus checkLength={checkLength2} hasChecks={hasChecks} label="Protocolo" />
        </div>
      </Paper>

      <CheckDetailTitle
        email={cadeCheck?.email}
        status={cadeCheck?.status}
        createdAt={cadeCheck?.createdAt}
        updatedAt={cadeCheck?.updatedAt}
      />

      {hasChecks && (
        <TimelineDotLine>
          <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
            <div className="c-detail-grid">
              <div className="c-detail-row">
                <Typography variant="subtitle1">Data Registro</Typography>
                <Typography variant="subtitle3">{detail?.data_registro ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Interessados</Typography>
                <Typography variant="subtitle3">{detail?.interessados ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Processo</Typography>
                <Typography variant="subtitle3">{detail?.processo ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">Tipo</Typography>
                <Typography variant="subtitle3">{detail?.tipo ?? '---'}</Typography>
              </div>
              <div className="c-detail-row">
                <Typography variant="subtitle1">URL</Typography>
                <Typography variant="subtitle3" sx={{ wordBreak: 'break-all' }}>
                  {detail?.url ?? '---'}
                </Typography>
              </div>
            </div>
          </Paper>
        </TimelineDotLine>
      )}

      {detail?.andamentos && Array.isArray(detail.andamentos) && detail.andamentos.length > 0 && (
        <>
          <Typography variant="h6">Andamentos</Typography>
          {detail?.andamentos.map((andamento, index) => (
            <TimelineDotLine key={index}>
              <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
                <div className="c-detail-grid">
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Data/Hora</Typography>
                    <Typography variant="subtitle3">{andamento.datahora ?? '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Descrição</Typography>
                    <Typography variant="subtitle3">{andamento.descricao ?? '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Unidade</Typography>
                    <Typography variant="subtitle3">{andamento.unidade ?? '---'}</Typography>
                  </div>
                </div>
              </Paper>
            </TimelineDotLine>
          ))}
        </>
      )}

      {detail?.protocolos && Array.isArray(detail.protocolos) && detail.protocolos.length > 0 && (
        <>
          <Typography variant="h6">Protocolos</Typography>
          {detail?.protocolos.map((protocolo, index) => (
            <TimelineDotLine key={index}>
              <Paper variant="rootOutlined" elevation={0} sx={{ flex: 1 }}>
                <div className="c-detail-grid">
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Data</Typography>
                    <Typography variant="subtitle3">{protocolo.data ?? '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Registro</Typography>
                    <Typography variant="subtitle3">{protocolo.data_registro ?? '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Documento</Typography>
                    <Typography variant="subtitle3">{protocolo.documento ?? '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Tipo</Typography>
                    <Typography variant="subtitle3">{protocolo.tipo ?? '---'}</Typography>
                  </div>
                  <div className="c-detail-row">
                    <Typography variant="subtitle1">Unidade</Typography>
                    <Typography variant="subtitle3">{protocolo.unidade ?? '---'}</Typography>
                  </div>
                </div>
              </Paper>
            </TimelineDotLine>
          ))}
        </>
      )}

      {cadeCheck?.checkDetails?.information && (
        <Paper variant="rootOutlined" elevation={0}>
          <Typography variant="subtitle1">{t('common:information')}</Typography>
          <Typography variant="subtitle3">{cadeCheck.checkDetails.information}</Typography>
        </Paper>
      )}
    </>
  )
}

export default CheckCade
